module.exports = __webpack_public_path__ + "static/img/tools@2x.fc9e2ec0.png";